import React from "react";

const TermofUse = () => {
  return ( 
    <section id="h4-pricing" className="relative w-full overflow-hidden">
      <div className="w-full h4-pricing-wrapper pb-[6rem] md:pb-[8rem] max-md:pt-[120px] md:pt-[160px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="title-area w-full flex justify-center">
              <div className="flex flex-col items-center">
                <div className="py-0.5 px-5 bg-[#1D109E07] border-[#1D109E1e] border rounded-[30px] font-medium text-[#1D109E] mb-5">
                  <span>Terms Of Use</span>
                </div>
                <div className="mb-[60px]">
                  <h2 className="text-main-black font-semibold text-24 sm:text-48 text-center max-w-[519px]">
                    Truvana OPD
                  </h2>
                </div>
              </div>
            </div>
            <div className="md:px-[100px]">
              <p className="mb-[10px]">
                These Terms &amp; Conditions (“Terms”) govern your access to and
                use of the Truvana OPD website (the “Website”) and the
                SaaS-based healthtech infrastructure we provide (the “Service”).
                By accessing or using the Website or Service, you agree to be
                bound by these Terms.
              </p>
              <p className="mb-[10px]">
                <strong>1. Definitions</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  <strong>“Truvana OPD”</strong> refers to Truvana OPD Pvt. Ltd., the provider of the Service.
                </p>
                <p className="mb-[10px]">
                  <strong>“You”</strong> refers to the individual or entity
                  accessing or using the Website or Service.
                </p>
                <p className="mb-[10px]">
                  <strong>“Content”</strong> refers to any information, data,
                  text, software, code, or other materials displayed on or
                  available through the Website or Service.
                </p>
                <p className="mb-[10px]">
                  <strong>“User”</strong> refers to any individual or entity who
                  accesses or uses the Website or Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>2. Use of the Website and Service</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  You may only use the Website and Service for lawful purposes
                  and in accordance with these Terms.
                </p>
                <p className="mb-[10px]">You agree not to use the Website or Service:</p>
                <div style={{ paddingLeft: 10 }}>
                  <p className="mb-[10px]">
                    • In a manner that could damage, disable, overburden, or
                    impair the Website or Service.
                  </p>
                  <p className="mb-[10px]">
                    • To interfere with any other user’s enjoyment of the
                    Website or Service.
                  </p>
                  <p className="mb-[10px]">
                    To gain unauthorized access to the Website or Service, or
                    any computer systems or networks connected to the Website or
                    Service.
                  </p>
                  <p className="mb-[10px]">
                    • To upload, transmit, or store any content that is
                    unlawful, harassing, defamatory, obscene, or otherwise
                    objectionable.
                  </p>
                  <p className="mb-[10px]">• To violate any applicable laws or regulations.</p>
                </div>
              </div>
              <p className="mb-[10px]">
                <strong>3. User Content</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  You are solely responsible for any content you upload,
                  transmit, or store on the Website or Service.
                </p>
                <p className="mb-[10px]">
                  You grant Truvana OPD&nbsp; Company a non-exclusive,
                  royalty-free license to use, reproduce, modify, publish, and
                  distribute your User Content in connection with the Website
                  and Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>4. Intellectual Property</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  The Website and Service, including all Content, are protected
                  by copyright, trademark, and other intellectual property laws.
                </p>
                <p className="mb-[10px]">
                  You agree not to remove, alter, or obscure any copyright
                  notices or other proprietary notices placed on the Website or
                  Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>5. Disclaimers</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  THE WEBSITE AND SERVICE ARE PROVIDED “AS IS” AND WITHOUT
                  WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED. CLICK FOR
                  DOCTOR DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT LIMITED
                  TO, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                  PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                </p>
                <p className="mb-[10px]">
                  Truvana OPD DOES NOT WARRANT THAT THE WEBSITE OR SERVICE WILL
                  BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE
                  CORRECTED, OR THAT THE WEBSITE OR SERVICE IS FREE OF VIRUSES
                  OR OTHER HARMFUL COMPONENTS.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>6. Limitation of Liability</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  Truvana OPD SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
                  INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
                  ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE
                  OR SERVICE.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>7. Term and Termination</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  These Terms shall remain in full force and effect until
                  terminated by you or Truvana OPD.
                </p>
                <p className="mb-[10px]">
                Truvana OPD may terminate these Terms at any time, with or
                  without cause, upon written notice to you.
                </p>
                <p className="mb-[10px]">
                  You may terminate these Terms by discontinuing your use of the
                  Website and Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>8. Governing Law</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  These Terms shall be governed by and construed in accordance
                  with the laws of India.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>9. Entire Agreement</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  These Terms constitute the entire agreement between you and
                  Truvana OPD with respect to the use of the Website and
                  Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>10. Severability</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  If any provision of these Terms is held to be invalid or
                  unenforceable, such provision shall be struck and the
                  remaining provisions shall remain in full force and effect.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>11. Waiver</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                  No waiver of any provision of these Terms shall be deemed a
                  further or continuing waiver of such provision or any other
                  provision.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>12. Update to Terms</strong>
              </p>
              <div>
                <p className="mb-[10px]">
                Truvana OPD may update these Terms at any time by posting the
                  amended terms on the Website. Your continued use of the
                  Website or Service following the posting of amended Terms
                  constitutes your acceptance of the amended Terms.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>13. Contact Us</strong>
              </p>
              <p className="mb-[10px]">
                If you have any questions about these Terms, please contact us
                at support@truvanaopd.com.
              </p>
            </div>
          </div>
        </div>
        <div className="shape-1 absolute left-40 top-96 z-10">
          <img src="assets/images/home-four/shape-1.webp" alt="" />
        </div>
        <div className="shape-2 absolute right-96 top-96 z-10">
          <img src="assets/images/home-four/shape-2.webp" alt="" />
        </div>
        <div className="shape-3 absolute left-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-3.webp" alt="" />
        </div>
        <div className="shape-4 absolute right-96 top-[550px] z-10">
          <img src="assets/images/home-four/shape-4.webp" alt="" />
        </div>
      </div>
    </section>
  );
};

export default TermofUse;
